<div [formGroup]="invoiceAddressForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="name"
    placeholder="Nexato GmbH"
    label="Name">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="addressLine0"
    placeholder="Florengasse 18"
    label="Addresszeile 1">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="addressLine1"
    label="Addresszeile 2">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="postalCode"
    placeholder="36043"
    label="Postleitzahl">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="city"
    placeholder="Fulda"
    label="Ort">
  </nx-edit-text-input>
  <nx-edit-selectCountry-input
    formControlName="country">
  </nx-edit-selectCountry-input>
  <nx-edit-select-input
  formControlName="vatType"
  placeholder="Steuer-ID Typ"
  label="Steuer-ID Typ"
  [options]="vatTypeOptions">
  </nx-edit-select-input>
  <nx-edit-text-input
    formControlName="vatNumber"
    placeholder="DE123456789"
    label="Umsatzsteuer-Identifikationsnummer">
  </nx-edit-text-input>
<div>
